import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { listTags } from '../api/tags';

const TagsContext = createContext(null);

export function TagsProvider({ children }) {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    listTags({ pagination: { limit: 100, offset: 0 } })
      .then((data) => {
        setTags(data.tags || []);
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const value = useMemo(
    () => ({ tags, loading, error }),
    [tags, loading, error],
  );

  return <TagsContext.Provider value={value}>{children}</TagsContext.Provider>;
}

export function useTags() {
  const context = useContext(TagsContext);
  if (!context) {
    throw new Error('useTags must be used within TagsProvider');
  }
  return context;
}
